var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStartDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1242 20.9999C18.6956 20.9999 20.7801 18.9154 20.7801 16.3441C20.7801 13.7727 18.6956 11.6882 16.1242 11.6882C13.5529 11.6882 11.4684 13.7727 11.4684 16.3441C11.4684 18.9154 13.5529 20.9999 16.1242 20.9999Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64421 3H5.27048V4.37373H6.64421V3Z",
    fill: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.704 3H16.3303V4.37373H17.704V3Z",
    fill: "#8A92A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58533 12.0274C8.97444 12.0274 9.28988 11.7119 9.28988 11.3228C9.28988 10.9337 8.97444 10.6183 8.58533 10.6183C8.19621 10.6183 7.88077 10.9337 7.88077 11.3228C7.88077 11.7119 8.19621 12.0274 8.58533 12.0274Z",
    fill: "#8A92A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1978 20.2771H4.38378C4.20202 20.2771 4.02205 20.2413 3.85413 20.1718C3.68621 20.1022 3.53365 20.0002 3.40515 19.8717C3.27664 19.7431 3.17472 19.5905 3.10521 19.4226C3.03569 19.2547 2.99994 19.0747 3 18.8929V5.75793C3 5.39092 3.14579 5.03895 3.4053 4.77945C3.66481 4.51994 4.01678 4.37415 4.38378 4.37415H18.6606C18.8423 4.37409 19.0223 4.40984 19.1902 4.47935C19.3582 4.54887 19.5108 4.65079 19.6393 4.77929C19.7679 4.90779 19.8698 5.06036 19.9394 5.22827C20.009 5.39619 20.0448 5.57617 20.0448 5.75793V11.1262",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00041 9.01123H20.0448",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71646 12.0274C6.10558 12.0274 6.42102 11.7119 6.42102 11.3228C6.42102 10.9337 6.10558 10.6183 5.71646 10.6183C5.32734 10.6183 5.0119 10.9337 5.0119 11.3228C5.0119 11.7119 5.32734 12.0274 5.71646 12.0274Z",
    fill: "#8A92A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58533 14.9099C8.97444 14.9099 9.28988 14.5945 9.28988 14.2054C9.28988 13.8162 8.97444 13.5008 8.58533 13.5008C8.19621 13.5008 7.88077 13.8162 7.88077 14.2054C7.88077 14.5945 8.19621 14.9099 8.58533 14.9099Z",
    fill: "#8A92A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65761 14.9099C6.04672 14.9099 6.36216 14.5945 6.36216 14.2054C6.36216 13.8162 6.04672 13.5008 5.65761 13.5008C5.26849 13.5008 4.95305 13.8162 4.95305 14.2054C4.95305 14.5945 5.26849 14.9099 5.65761 14.9099Z",
    fill: "#8A92A6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5377 12.0274C11.9268 12.0274 12.2422 11.7119 12.2422 11.3228C12.2422 10.9337 11.9268 10.6183 11.5377 10.6183C11.1486 10.6183 10.8331 10.9337 10.8331 11.3228C10.8331 11.7119 11.1486 12.0274 11.5377 12.0274Z",
    fill: "#8A92A6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65761 17.8803C6.04672 17.8803 6.36216 17.5649 6.36216 17.1757C6.36216 16.7866 6.04672 16.4712 5.65761 16.4712C5.26849 16.4712 4.95305 16.7866 4.95305 17.1757C4.95305 17.5649 5.26849 17.8803 5.65761 17.8803Z",
    fill: "#8A92A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58533 17.8803C8.97444 17.8803 9.28988 17.5649 9.28988 17.1757C9.28988 16.7866 8.97444 16.4712 8.58533 16.4712C8.19621 16.4712 7.88077 16.7866 7.88077 17.1757C7.88077 17.5649 8.19621 17.8803 8.58533 17.8803Z",
    fill: "#8A92A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64421 4.35425H5.27048V5.72798H6.64421V4.35425Z",
    fill: "#8A92A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.704 4.35425H16.3303V5.72798H17.704V4.35425Z",
    fill: "#8A92A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1755 13.1942V16.2517H19.2331",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStartDate);
export default __webpack_public_path__ + "static/media/ic_start_date.7a7c0fff0f3d51808c61ad8688e79c17.svg";
export { ForwardRef as ReactComponent };